export const routeConfig = [
  {
    path: '/cg-landing',
    name: 'cg-landing',
    redirect: '/',
    meta: {
      needLogin: false,
    },
  },
  {
    path: '/ys-landing',
    name: 'ys-landing',
    redirect: '/',
    meta: {
      needLogin: false,
    },
  },
  {
    // 首页，落地页
    path: '/',
    name: 'index',
    component: () => import('./components/landing/index.vue'),
    meta: {
      needLogin: false,
    },
  },
  // 银行账号信息
  {
    path: '/cumtomer/account/bank',
    name: 'cumtomer-account-bank',
    meta: { title: '银行账户信息' },
    component: () => import('@/views/customer-center/account/index.vue'),
  },
  {
    // 产品落地页
    path: '/product',
    name: 'product-index',
    component: () => import('./components/landing/ProductIndex.vue'),
    meta: {
      needLogin: false,
    },
  },
]
